import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import './index.scss'
import './detail.scss'

class Tab extends PureComponent {
  constructor(props) {
    super(props)
    this.tabIndexes = [props.tabIndex]
  }

  onSelectTab(index) {
    if (!this.tabIndexes.includes(index)) {
      this.tabIndexes.push(index)
    }

    this.props.onSelectTab(index)
  }

  getActiveClasses(className, routeIndex, tabIndex) {
    let classes = className

    if (routeIndex === tabIndex) {
      classes += ` ${className}--active`
    }
    return classes
  }

  renderTab(route, index, tabIndex) {
    if ((this.tabIndexes.includes(index) && !route.rerender) || tabIndex === index) {
      return route.component
    }
    return null
  }

  render() {
    const { routes, renderLabel, tabIndex } = this.props

    return (
      <div className="tab">
        <div className="tab__list">
          {
            routes.map((route, index) => (
              <div
                key={route.key}
                className={this.getActiveClasses('tab__item', index, tabIndex)}
                onClick={() => this.onSelectTab(index)}
              >
                {
                  renderLabel
                    ? renderLabel(route)
                    : <span>{route.label}</span>
                }
              </div>
            ))
          }
        </div>

        <div className="tab__content">
          {
            routes.map((route, index) => (
              <div
                key={route.key}
                className={this.getActiveClasses('tab__panel', index, tabIndex)}
              >
                {this.renderTab(route, index, tabIndex)}
              </div>
            ))
          }
        </div>
      </div>
    )
  }
}

Tab.defaultProps = {
  onSelectTab: () => null,
  tabIndex: 0
}

Tab.propTypes = {
  routes: PropTypes.array.isRequired,
  renderLabel: PropTypes.func,
  onSelectTab: PropTypes.func,
  tabIndex: PropTypes.number
}

export default Tab